import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { BootstrapVue} from 'bootstrap-vue'
import "./plugins/socketPlugin";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
//Vue.use(IconsPlugin)
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
